<template>
    <div class="main-style">
        <Search></Search>
        <HomeMain></HomeMain>
    </div>
</template>

<script>
import Search from "./Search";
import HomeMain from "./HomeMain";

export default {
    name: "LevelOneSearch",
    components: {
        Search,
        HomeMain
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LevelOneSearch.vue